import axiosClient from "@/utils/axios-client";
import {
  GetClaimableProductsParams,
  GetClaimableProductsResponse,
  GetClaimsResponse,
  GetClaimDetailResponse,
  PostClaimRequest,
  UpdateClaimDetailRequest,
} from "@/features/my-order/features/order-history/features/claim/types";
import { toSnakeKeyObject } from "@/utils/case";

const url = {
  getClaimableProducts: (
    companyType: string,
    companyId: number,
    orderSheetSetId: string
  ) =>
    `/${companyType}/${companyId}/order-sheet-sets/${orderSheetSetId}/claims/products`,
  getClaimList: (
    companyType: string,
    companyId: number,
    orderSheetSetId: string
  ) =>
    `/${companyType}/${companyId}/order-sheet-sets/${orderSheetSetId}/claims`,
  getClaimDetail: (
    companyType: string,
    companyId: number,
    orderSheetSetId: string,
    userRequestDetailId: number
  ) =>
    `/${companyType}/${companyId}/order-sheet-sets/${orderSheetSetId}/claims/${userRequestDetailId}`,

  postClaims: (
    companyType: string,
    companyId: number,
    orderSheetSetId: string
  ) =>
    `/${companyType}/${companyId}/order-sheet-sets/${orderSheetSetId}/claims`,
  updateClaimDetail: (
    companyType: string,
    companyId: number,
    orderSheetSetId: string,
    userRequestDetailId: number
  ) =>
    `/${companyType}/${companyId}/order-sheet-sets/${orderSheetSetId}/claims/${userRequestDetailId}`,
  withdrawClaimDetail: (
    companyType: string,
    companyId: number,
    orderSheetSetId: string,
    userRequestDetailId: number
  ) =>
    `/${companyType}/${companyId}/order-sheet-sets/${orderSheetSetId}/claims/${userRequestDetailId}`,
};

export const orderHistoryClaimApi = {
  getClaimableProducts: async (
    companyType: string,
    companyId: number,
    orderSheetSetId: string,
    params?: GetClaimableProductsParams
  ) => {
    const { data } = await axiosClient.get<GetClaimableProductsResponse>(
      url.getClaimableProducts(companyType, companyId, orderSheetSetId),
      { params }
    );

    return data;
  },
  getClaimList: async (
    companyType: string,
    companyId: number,
    orderSheetSetId: string
  ) => {
    const { data } = await axiosClient.get<GetClaimsResponse>(
      url.getClaimList(companyType, companyId, orderSheetSetId)
    );

    return data;
  },
  getClaimDetail: async (
    companyType: string,
    companyId: number,
    orderSheetSetId: string,
    userRequestDetailId: number
  ) => {
    const { data } = await axiosClient.get<GetClaimDetailResponse>(
      url.getClaimDetail(
        companyType,
        companyId,
        orderSheetSetId,
        userRequestDetailId
      )
    );

    return data;
  },

  postClaims: async (
    companyType: string,
    companyId: number,
    orderSheetSetId: string,
    params: PostClaimRequest
  ) =>
    await axiosClient.post(
      url.postClaims(companyType, companyId, orderSheetSetId),
      toSnakeKeyObject(params)
    ),
  updateClaimDetail: async (
    companyType: string,
    companyId: number,
    orderSheetSetId: string,
    userRequestDetailId: number,
    params: UpdateClaimDetailRequest
  ) =>
    await axiosClient.put(
      url.updateClaimDetail(
        companyType,
        companyId,
        orderSheetSetId,
        userRequestDetailId
      ),
      toSnakeKeyObject(params)
    ),
  withdrawClaimDetail: async (
    companyType: string,
    companyId: number,
    orderSheetSetId: string,
    userRequestDetailId: number
  ) =>
    await axiosClient.delete(
      url.withdrawClaimDetail(
        companyType,
        companyId,
        orderSheetSetId,
        userRequestDetailId
      )
    ),
};
